var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    stroke: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.115 11.44H19.864L18.889 14.365H15.25V17.635H19.864V20.56H12.115V11.44ZM4 28H27.979V4H4V28Z",
    fill: "currentColor"
  })));
};

export default __webpack_public_path__ + "static/media/type_quality.00973da8.svg";
export { SvgComponent as ReactComponent };